import script from "./usuario-nao-logado-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./usuario-nao-logado-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__